export default __webpack_public_path__ + "static/media/img-error-bg-dark.420ab717.svg";